import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage from '../../../../assets/images/work/sn-nex/NEX_slider_1.jpg';
import projectImage1 from '../../../../assets/images/work/sn-nex/NEX_slider_2.jpg';
import projectImage2 from '../../../../assets/images/work/sn-nex/NEX_slider_3.jpg';
import projectImage3 from '../../../../assets/images/work/sn-nex/NEX_slider_4.jpg';
import projectImage4 from '../../../../assets/images/work/sn-nex/NEX_slider_5.jpg';
import projectImage5 from '../../../../assets/images/work/sn-nex/NEX_slider_6.jpg';
import projectImage6 from '../../../../assets/images/work/sn-nex/NEX_slider_7.jpg';

import Data_SNNEX from './Data_SNNEX';

function Work_SNNEX() {
    const canonical = 'https://studio.norcat.org/OurWork/sn-nex';
    const title = 'Nature Exchange | Studio NORCAT - Driven by experiences that matter.';
    const description = 'Developed by Studio NORCAT, Nature Exchange is a digital platform that helps Science North deliver curiosity-driven exploration, collection, and learning experiences wherever visitors engage.';

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage5}`}
                ogImageAlt="Preview of the Nature Exchange platform project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage5}`}
                twitterImageAlt="Preview of the Nature Exchange platform project"
            />
            <DetailedHeader
                heading="Designed to meet people where exploration happens"
                client="Science North"
                service="Platform"
                date="2025-Present"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                images={[
                    {
                        image: projectImage5,
                        alt: 'Nature Exchange project screenshot 1',
                    },
                    {
                        image: projectImage1,
                        alt: 'Nature Exchange project screenshot 2',
                    },
                    {
                        image: projectImage2,
                        alt: 'Nature Exchange project screenshot 3',
                    },
                    {
                        image: projectImage3,
                        alt: 'Nature Exchange project screenshot 4',
                    },
                    {
                        image: projectImage6,
                        alt: 'Nature Exchange project screenshot 5',
                    },
                    {
                        image: projectImage4,
                        alt: 'Nature Exchange project screenshot 6',
                    },
                     {
                        image: projectImage,
                        alt: 'Nature Exchange project screenshot 7',
                    },
                ]}
            />

            {Data_SNNEX.content}
        </>
    );
}

export default Work_SNNEX;
